import { useState } from "react";
import TabsHeader from "./TabsHeader";
import TabsContent from "./TabsContent";

export default function Tabs({ tab }) {
  const [selected, setSelected] = useState(tab[0]);
  return (
    <>
      <div className="ob-tabs">
        <TabsHeader selected={selected} setSelected={setSelected} tab={tab} />

        <TabsContent selected={selected} />
      </div>
    </>
  );
}
